import React, { useState, useEffect } from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  loaderWrapper: {
    position: (props) => (props.fullscreen ? "fixed" : "absolute"),
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: (props) =>
      props.fullscreen ? "blur(10px)" : "none", // Add blur for fullscreen
    backgroundColor: (props) =>
      props.fullscreen
        ? "rgba(0, 0, 0, 0.4)"
        : "transparent",
    zIndex: (props) => (props.fullscreen ? 1300 : 999),
    borderRadius: (props) => (props.fullscreen ? "0" : "12px"),
    pointerEvents: "auto",
  },
  loaderContainer: {
    position: "relative",
    width: "50px",
    height: "50px",
  },
  loaderImage: {
    position: "absolute",
    width: "100%",
    height: "100%",
    animation: "spin 1s linear infinite",
  },
  loaderText: {
    marginTop: "10px",
    color: (props) => (props.isDark ? "#fff" : "#000"),
    fontSize: "14px",
    textAlign: "center",
  },
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
}));

export default function ScreenLoader({ open, fullscreen = false, isDark = false }) {
  const classes = useStyles({ fullscreen, isDark });
  const images = [
    `${process.env.REACT_APP_IMAGE_BASE_URL}/loading.svg`,
    `${process.env.REACT_APP_IMAGE_BASE_URL}/loading2.svg`,
    `${process.env.REACT_APP_IMAGE_BASE_URL}/loading3.svg`,
  ];
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  if (!open) return null;

  return (
    <Box className={classes.loaderWrapper}>
      <Box className={classes.loaderContainer}>
        <img src={images[currentImage]} className={classes.loaderImage} alt="Loading..." />
      </Box>
    </Box>
  );
}
